module.exports = __webpack_public_path__ + "img/Storage=Auto-Off.58e3c034.svg";